module.exports = __webpack_public_path__ + "img/logo-dark.e63b8ab0.svg";